import qs from 'qs';
import type { AxiosResponse } from 'axios';
import axios from 'axios';
import type { ReviewFilter } from '@shared/domain/review/index.js';

export interface FetchReviewsParameters {
  [key: string]: any;
  filter: ReviewFilter;
  limit?: number;
  token: string;
  userId?: number;
}

export const fetchReviews = async (parameters: FetchReviewsParameters) => {
  const { filter, limit, token, userId, ...rest } = parameters;
  const url = `${import.meta.env.VITE_API_BASE_URL}/review`;

  const fullParameters = {
    limit,
    searchType: filter,
    userId,
    ...rest,
  };

  try {
    const response: AxiosResponse = await axios.get(url, {
      headers: {
        Authorization: token,
      },
      params: fullParameters,
      paramsSerializer: (p) => {
        return qs.stringify(p, {
          arrayFormat: 'repeat',
          encode: true,
        });
      },
    });

    return response.data;
  } catch {
    throw new Error('Error fetching reviews');
  }
};
